(ns frontend.test.kanban-v2.subs
  (:require
   [re-frame.core :as rf]))


(defn db-sub
  "Define a simple subscription handler that just gets a top level value from the db."
  ([db-kw] (db-sub db-kw db-kw))
  ([sub-kw db-kw]
   (rf/reg-sub
    sub-kw
    (fn [db]
      (get db db-kw)))))

(db-sub :kanban/items)
(db-sub :kanban/view-settings)
(db-sub :kanban/card-settings)
(db-sub :kanban/group-by-attribute)


(rf/reg-sub
 :kanban/all-items-map
 :<-
 [:kanban/group-by-attribute]
 :<-
 [:kanban/items]
 (fn [[group-by-attribute items] query-v]
   (group-by group-by-attribute items)))

(rf/reg-sub
 :kanban/column-labels
 :<-
 [:kanban/all-items-map]
 (fn [all-items-map query-v]
   (vec (keys all-items-map))))

(rf/reg-sub
 :kanban/column-contents
 :<-
 [:kanban/all-items-map]
 (fn [all-items-map query-v]
   (vec (vals all-items-map))))

(rf/reg-sub
 :kanban/items-state
 :<-
 [:kanban/column-labels]
 :<-
 [:kanban/column-contents]
 (fn [[column-labels column-contents] query-v]
   {:column-labels   column-labels
    :column-contents column-contents}))

